import { TableCell, TextField } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
// import TableFooter from "@material-ui/core/TableFooter";
import TableRow from "@material-ui/core/TableRow";
import DeleteIcon from "@material-ui/icons/Delete";
import CardTitle from "@saleor/components/CardTitle";
import Checkbox from "@saleor/components/Checkbox";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
import {
  SortableTableBody,
  SortableTableRow
} from "@saleor/components/SortableTable";
import StatusLabel from "@saleor/components/StatusLabel";
import TableCellAvatar, {
  AVATAR_MARGIN
} from "@saleor/components/TableCellAvatar";
import TableHead from "@saleor/components/TableHead";
// import TablePagination from "@saleor/components/TablePagination";
import { FormChange } from "@saleor/hooks/useForm";
import { Redemption_redemption } from "@saleor/specialOffer/types/Redemption";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { maybe, renderCollection } from "../../../misc";
import { ListActions, ListProps2, ReorderAction } from "../../../types";
import { SpecialOfferFormData } from "../SpecialOfferDetails";
export interface SpecialOfferVariantsPoprs extends ListProps2, ListActions {
  specialOffer: Redemption_redemption;
  onVariantAssign: () => void;
  onVariantUnassign: (id: string) => void;
  onChange: FormChange;
  data: SpecialOfferFormData;
  onVariantReorder: ReorderAction;
}

const useStyles = makeStyles(
  theme => ({
    colActions: {
      "&:last-child": {
        paddingRight: 0
      },
      width: 76 + theme.spacing(0.5)
    },
    colName: {
      paddingLeft: 0,
      width: 200
    },
    colGrab: {
      width: 60
    },
    colNameLabel: {
      marginLeft: AVATAR_MARGIN + theme.spacing(3)
    },
    colPublished: {
      width: 150
    },
    colType: {
      width: 130,
      padding: 0
    },
    colPrice: {
      width: 200
    },
    colNum: {
      width: 200
    },
    table: {
      tableLayout: "fixed"
    },
    tableRow: {
      cursor: "pointer"
    }
  }),
  { name: "SpecialOfferVariants" }
);

const SpecialOfferVariants: React.FC<SpecialOfferVariantsPoprs> = props => {
  const {
    specialOffer,
    disabled,
    // pageInfo,
    onRowClick,
    // onPreviousPage,
    onVariantAssign,
    onVariantUnassign,
    // onNextPage,
    isChecked,
    selected,
    toggle,
    toggleAll,
    toolbar,
    onChange,
    onVariantReorder,
    data
  } = props;
  const classes = useStyles(props);
  const numberOfColumns = 8;

  const intl = useIntl();
  const hasSaleVariants = maybe(() => specialOffer.redemptionVariants)?.length;

  return (
    <Card>
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "Eligible SKU",
          description: "section header"
        })}
        toolbar={
          <Button color="primary" onClick={onVariantAssign}>
            <FormattedMessage
              defaultMessage="Assign SKU"
              description="button"
            />
          </Button>
        }
      />
      <ResponsiveTable>
        <colgroup>
          {hasSaleVariants && (
            <>
              <col className={classes.colGrab} />
              <col />
            </>
          )}
          <col className={classes.colName} />
          <col className={classes.colType} />
          <col className={classes.colType} />
          <col className={classes.colPrice} />
          <col className={classes.colPublished} />
          <col className={classes.colActions} />
        </colgroup>
        <TableHead
          colSpan={numberOfColumns}
          selected={selected}
          disabled={disabled}
          items={maybe(() => specialOffer.redemptionVariants)}
          toggleAll={toggleAll}
          toolbar={toolbar}
          dragRows
        >
          <TableCell className={classes.colName}>
            <span className={hasSaleVariants ? classes.colNameLabel : ""}>
              <FormattedMessage defaultMessage="Product Name" />
            </span>
          </TableCell>
          <TableCell className={classes.colType}>
            <FormattedMessage defaultMessage="SKU" />
          </TableCell>
          <TableCell className={classes.colType}>
            <FormattedMessage defaultMessage="SKU Name" />
          </TableCell>
          <TableCell className={classes.colPrice}>
            <FormattedMessage defaultMessage="Discount Price" />
          </TableCell>
          <TableCell className={classes.colPublished}>
            <FormattedMessage
              defaultMessage="Published"
              description="product is published"
            />
          </TableCell>
          <TableCell className={classes.colActions} />
        </TableHead>
        {/* <TableFooter>
          <TableRow>
            <TablePagination
              colSpan={numberOfColumns}
              hasNextPage={pageInfo && !disabled ? pageInfo.hasNextPage : false}
              onNextPage={onNextPage}
              hasPreviousPage={
                pageInfo && !disabled ? pageInfo.hasPreviousPage : false
              }
              onPreviousPage={onPreviousPage}
            />
          </TableRow>
        </TableFooter> */}
        <SortableTableBody onSortEnd={onVariantReorder}>
          {renderCollection(
            maybe(() => specialOffer?.redemptionVariants),
            (variant, index) => {
              if (!variant) {
                return undefined;
              }
              const isSelected = variant
                ? isChecked(variant.variant.id)
                : false;
              return (
                <SortableTableRow
                  className={classes.tableRow}
                  index={index || 0}
                  hover={!!variant}
                  key={variant ? variant.id : "skeleton"}
                  selected={isSelected}
                >
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={isSelected}
                      disabled={disabled}
                      disableClickPropagation
                      onChange={() => toggle(variant.variant.id)}
                    />
                  </TableCell>
                  <TableCellAvatar
                    className={classes.colName}
                    thumbnail={maybe(() => variant.variant.thumbnail.url)}
                    onClick={
                      variant &&
                      onRowClick(variant.variant.product.id, variant.variant.id)
                    }
                  >
                    {maybe<React.ReactNode>(
                      () => variant.variant.product.name,
                      <Skeleton />
                    )}
                  </TableCellAvatar>
                  <TableCell className={classes.colType}>
                    {maybe<React.ReactNode>(
                      () => variant.variant.sku,
                      <Skeleton />
                    )}
                  </TableCell>
                  <TableCell className={classes.colType}>
                    {maybe<React.ReactNode>(
                      () => variant.variant.name,
                      <Skeleton />
                    )}
                  </TableCell>
                  <>
                    <TableCell className={classes.colPrice}>
                      <TextField
                        disabled={disabled}
                        label={intl.formatMessage({
                          defaultMessage: "Discount Price",
                          description: "specialOffer specialOffer"
                        })}
                        onClick={event => event.stopPropagation()}
                        name={
                          ("redemptionVariants." +
                            index +
                            ".discountPrice") as keyof SpecialOfferFormData
                        }
                        value={data.redemptionVariants[index]?.discountPrice}
                        onChange={e => {
                          onChange(e);
                        }}
                      />
                    </TableCell>
                  </>
                  <TableCell className={classes.colPublished}>
                    {variant && variant.variant.isPublished !== undefined ? (
                      <StatusLabel
                        label={
                          variant.variant.isPublished
                            ? intl.formatMessage({
                                defaultMessage: "Published",
                                description: "product is published"
                              })
                            : intl.formatMessage({
                                defaultMessage: "Not published",
                                description: "product is not published"
                              })
                        }
                        status={
                          variant.variant.isPublished ? "success" : "error"
                        }
                      />
                    ) : (
                      <Skeleton />
                    )}
                  </TableCell>
                  <TableCell className={classes.colActions}>
                    <IconButton
                      disabled={!variant || disabled}
                      onClick={event => {
                        event.stopPropagation();
                        onVariantUnassign(variant.variant.id);
                      }}
                    >
                      <DeleteIcon color="primary" />
                    </IconButton>
                  </TableCell>
                </SortableTableRow>
              );
            },
            () => (
              <TableRow>
                <TableCell colSpan={numberOfColumns}>
                  <FormattedMessage defaultMessage="No variants found" />
                </TableCell>
              </TableRow>
            )
          )}
        </SortableTableBody>
      </ResponsiveTable>
    </Card>
  );
};
SpecialOfferVariants.displayName = "SpecialOfferVariants";
export default SpecialOfferVariants;
